import React from 'react';
import '../less/index.less';
import cards_img from '../img/cards_img.png';
import CardOrderModal from './../../CardOrderModal';

export default function template() {
    return (
      <>
        <div className="download-app-bottom">
          <div className="container">
            <div className="download-app-bottom__body">
              <img className="download-app-bottom__img" src={cards_img} alt="cards image"/>
              <div className="download-app-bottom__left">
                <h2 className="download-app-bottom__title">{this.l10n('DOWNLOAD_APP_BOTTOM_TITLE')}</h2>
                <div className="download-app-bottom__text">{this.l10n('DOWNLOAD_APP_BOTTOM_TEXT')}</div>
                <button className="download-app-bottom__btn" onClick={this.toggleModal}>{this.l10n('DOWNLOAD_APP_BOTTOM_BTN')}</button>
              </div>
            </div>
          </div>
        </div>
        {this.state.showModal ? 
          <CardOrderModal closeModal={this.toggleModal} downloadAppBottom={true} isOpen={this.state.showModal}/> : ''
        }
      </>
    );
}
